<div class="map">
    <ng-container *ngTemplateOutlet="loadingOverlay" />

    <kp-map
        #map
        [data]="mapData"
        [tileProvider]="tileProvider"
        [mapTilerToken]="mapTilerToken"
        [defaultLocation]="defaultLocation"
        [isEditable]="locationsPowerMap ? false : isEditable"
        [locations]="locationsPowerMap"
        (mutation)="mapMutated($event)"
        (editStart)="editStart()"
        (editEnd)="editEnd()"
        (uploadImg)="uploadImg($event)"
        (setImg)="setImg($event)"
        (removeFeature)="removeFeature($event)"
        (featureClicked)="featureClicked($event)"
        (save)="save($event)"
        (cancel)="cancel()"
    ></kp-map>
    <!-- if no location yet.. -->
    <div class="control">
        <ng-container *ngIf="!hasLocation && !locationsPowerMap">
            <button
                mat-stroked-button
                (click)="setAsLocation()"
                (keydown.enter)="setAsLocation()"
                *ngIf="isZoomedInEnoughForPlaceLocation"
            >
                <mat-icon svgIcon="c-location"></mat-icon>
                Place location here
            </button>
            <div class="note" *ngIf="!isZoomedInEnoughForPlaceLocation">Zoom in to place location</div>
        </ng-container>
    </div>
</div>

<ng-template #loadingOverlay>
    <ng-container *ngIf="(loadingMapData$ | async) || isSaving">
        <div class="loading-overlay">
            <mat-progress-spinner
                [mode]="'indeterminate'"
                [value]="50"
                [color]="'accent'"
                [diameter]="48"
                [strokeWidth]="4"
            ></mat-progress-spinner>
        </div>
    </ng-container>
</ng-template>
